import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtiOrderDetailSliderModelService {
  public otiOrderDetailSlider: BehaviorSubject<boolean>;
  public otiOrderDetailAddSidenav: MatSidenav;
  otiOrderDetailCloseRqt: Subject<boolean>;
  orderNumber: BehaviorSubject<string>;
  orderType: BehaviorSubject<string>;
  constructor() {
    this.otiOrderDetailSlider = new BehaviorSubject(false);
    this.otiOrderDetailCloseRqt = new Subject();
    this.orderNumber = new BehaviorSubject(null);
    this.orderType = new BehaviorSubject(null);
  }

  activeSlider(value: string) {
    if (value === 'otiOrderDetailSlider') {
      this.otiOrderDetailSlider.next(true);
      this.otiOrderDetailAddSidenav.toggle();
    }
  }

  public setotiOrderDetailSideNav(otiOrderDetailSideNavObj: MatSidenav) {
    this.otiOrderDetailAddSidenav = otiOrderDetailSideNavObj;
  }

  public otiOrderDetailClose() {
    this.orderNumber.next(null);
    this.orderType.next(null);
    this.otiOrderDetailSlider.next(false);
    this.otiOrderDetailAddSidenav.close();
  }

}
